import axios from "axios";
import { get, set } from "lodash";

import { IDocument } from "../models/document.model";
import { PENDING, FULFILLED, REJECTED } from "./action-type.util";
import { IOption } from "../models/option.model";
import { ISecureUploadFile } from '../../store/models/secureUploadFile.model';

export const ACTION_TYPES = {
  FETCH_DOCUMENT_TYPES: "secureUploadDocumentType/FETCH_DOCUMENT_TYPES"
};

const initialState = {
  documentTypes: [],
  isDocumentTypesLoaded: false
};

export type SecureUploadDocumentTypeState = Readonly<typeof initialState>;

/**
 * SecureUpload Reducer
 */
export default (state: SecureUploadDocumentTypeState = initialState, action): SecureUploadDocumentTypeState => {
  switch (action.type) {
    // Pending
    case PENDING(ACTION_TYPES.FETCH_DOCUMENT_TYPES): {
      return {
        ...state
      };
    }

    // Fulfilled
    case FULFILLED(ACTION_TYPES.FETCH_DOCUMENT_TYPES): {
      const documentOptions = get(action, "payload.data");
      return {
        ...state,
        documentTypes: documentOptions
      };
    }

    // Rejected
    case REJECTED(ACTION_TYPES.FETCH_DOCUMENT_TYPES): {
      return {
        ...state
      };
    }

    default: {
      return {
        ...state
      };
    }
  }
};

/**
 * Fetch document types associated with the specified proposal .
 */
export const fetchDocumentTypes = () => {
  return {
    type: ACTION_TYPES.FETCH_DOCUMENT_TYPES,
    payload: axios.get(`secureupload/documenttypes`)
  };
};